import React, { lazy, Suspense } from 'react';
import { Route, RouteProps, Switch } from 'react-router-dom';
import { IMenuItems } from '../modules/ApplicationLayout/ApplicationLayout';
import CentredSpinner from '../components/CentredSpinner';
import IRouteProps from './IRouteProps';
import ROUTE_PATHS from './RoutePaths';

const SessionPage = lazy(() => import('../modules/SessionPage'));
const LoginPage = lazy(() => import('../modules/LoginPage'));
const ApplicationPages = lazy(() => import('../utils/ApplicationPages'));

export const generateRoutes = (routes: RouteProps[]) =>
    routes.map((route) => <Route key={route.path?.toString()} {...route} />);

// Here you should add routes to modules
const routesModules: IRouteProps[] = [
    {
        // @ts-ignore
        component: SessionPage,
        path: ROUTE_PATHS.IN_SESSION,
        exact: true,
    },
    {
        // @ts-ignore
        component: LoginPage,
        path: ROUTE_PATHS.LOGIN,
        exact: true,
        fullScreen: true,
    },
];

// Here you should add tabs
export const headerMenuItems: IMenuItems[] = [
    {
        key: 'session',
        path: ROUTE_PATHS.IN_SESSION,
        name: 'In Session',
    },
];

// Generates routes that should be rendered in content below header
const inLayoutRoutes = (
    <Suspense fallback={<CentredSpinner />}>
        <Switch>
            {generateRoutes(routesModules.filter((route) => !route.fullScreen))}
        </Switch>
    </Suspense>
);
// Wrapper for ApplicationPage
const ApplicationPagePropsWrapper = () => (
    <ApplicationPages
        routes={inLayoutRoutes}
        headerMenuItems={headerMenuItems}
    />
);

export const routesComponents: IRouteProps[] = [
    ...routesModules,
    {
        // @ts-ignore
        component: ApplicationPagePropsWrapper,
        path: ROUTE_PATHS.MAIN,
        fullScreen: true,
    },
];
